
<style scoped>
.query-form {
    margin-top: 40px;
}
</style>

<template>
     <div>
        <h1>创建用户</h1>
        <div class="query-form">
            <el-form :model="ruleSignUp" status-icon :rules="signUpRules" ref="ruleSignUp" class="demo-ruleForm">
                <el-form-item label="用户名" label-width="80px" prop="accountName">
                    <el-input type="text" v-model="ruleSignUp.accountName" auto-complete="off" placeholder="请输入用户名" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="密码" label-width="80px" prop="password">
                    <el-input type="password" label-width="80px" v-model="ruleSignUp.password" auto-complete="off" placeholder="请输入密码" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" label-width="80px" prop="confirmPassword">
                    <el-input type="password" v-model="ruleSignUp.confirmPassword" auto-complete="off" placeholder="请再次输入密码" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="用户分组" label-width="80px">
                    <el-select v-model="ruleSignUp.userGroup" multiple style="width:300px;">
                        <el-option v-for="item in userGroup"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button class="button-width" type="primary" @click="subimtSignUp('ruleSignUp')">创建用户</el-button>
                </el-form-item>
            </el-form>
        </div>
     </div>
</template>

<script>
import app from '@/App.vue';
import {createUser} from '@/request/api';

export default {
    data() {
        var checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('用户名不能为空'));
            }
            callback();
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            }
            callback();
        };
        var confirmPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } 
            if (this.ruleSignUp.password != this.ruleSignUp.confirmPassword) {
                callback(new Error('您输入的密码不一致'));
            }
            callback();
        };
        return {
            activeName: 'signUp',
            userGroup: app.userGroupWithOutSu,
            dialogFormVisible: false,
            ruleSignUp: {
                accountName: '',
                password: '',
                confirmPassword: '',
                userGroup: 0
            },
            signUpRules: {
                accountName: [
                    { validator: checkName, trigger: 'blur'}
                ],
                password: [
                    { validator: validatePass, trigger: 'blur'}
                ],
                confirmPassword: [
                    { validator: confirmPass, trigger: 'blur'}
                ]
            }
        };
    },
    methods: {
        subimtSignUp(formName) {
            if (this.ruleSignUp.userGroup.length == 0) {
                this.$message.error('请选择用户分组');
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    createUser({
                        accountName: this.ruleSignUp.accountName,
                        password: this.ruleSignUp.password,
                        userGroupList: this.ruleSignUp.userGroup
                    }).then(res => {
                        var status = res.status;
                        var msg = res.msg;
                        if (status === '2') {
                            this.$message.error(msg);
                        } else {
                            this.$message.success("注册成功");
                            this.$refs['ruleSignUp'].resetFields();
                        }
                    })


                } else {
                    console.log('error');
                    return false;
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/user/createUser.vue